import { LockKeyholeOpen } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const LockKeyholeOpenIcon = createLucideIcon(LockKeyholeOpen);
